<!-- Invisible spacer: holds the nav bar height while menu data loads so the dark strip doesn't collapse -->
@if (isNavLoading && !cmsNavData && !menuItems.length) {
    <span class="dotcom-nav-spacer"></span>
<!-- CMS markets (e.g. en-US, es-US, zh-US): nav structure comes from Contentstack nav_header entries -->
} @else if (isCmsRoute) {
    @if (cmsNavData) {
        @for (section of cmsNavData.navHeaders; track $index) {
            @if (isShopSection(section)) {
                <span class="categoryLink dotcom-nav-item dotcom-nav-item--cms">
                    <button class="cms-nav-trigger"
                            type="button"
                            (click)="toggleCmsSection($event, -1)"
                            [attr.aria-expanded]="cmsOpenIndex === -1"
                            [attr.data-testid]="'dotcom-nav-shop'"
                            [class.cms-nav-trigger--active]="cmsOpenIndex === -1">
                        {{ formatNavLabel(section.header?.headerTitle ?? section.link?.label) }}
                        <i class="fa-solid fa-chevron-down cms-nav-chevron"
                           [class.cms-nav-chevron--open]="cmsOpenIndex === -1"></i>
                    </button>
                    <div class="dropdown-menu cms-mega-menu" [class.show]="cmsOpenIndex === -1">
                        <shop-nav-full-menu (closeMenu)="cmsOpenIndex = null"></shop-nav-full-menu>
                    </div>
                </span>
            <!-- Contentstack header entry: has a title + columns of links, renders as a mega-menu dropdown -->
            } @else if (section.header; as hdr) {
                <span class="categoryLink dotcom-nav-item dotcom-nav-item--cms">
                    <button class="cms-nav-trigger"
                            type="button"
                            (click)="toggleCmsSection($event, $index)"
                            [attr.aria-expanded]="cmsOpenIndex === $index"
                            [class.cms-nav-trigger--active]="cmsOpenIndex === $index">
                        {{ formatNavLabel(hdr.headerTitle) }}
                        <i class="fa-solid fa-chevron-down cms-nav-chevron"
                           [class.cms-nav-chevron--open]="cmsOpenIndex === $index"></i>
                    </button>
                    <div class="dropdown-menu cms-mega-menu" [class.show]="cmsOpenIndex === $index">
                        @for (col of hdr.columns; track col.columnTitle) {
                            <div class="cms-mega-menu__col">
                                @if (col.columnTitle) {
                                    <h6 class="cms-mega-menu__col-title">{{ col.columnTitle }}</h6>
                                }
                                <ul class="cms-mega-menu__items">
                                    @for (navItem of col.navItems; track navItem.link.href) {
                                        <li>
                                            <a class="cms-mega-menu__nav-link"
                                               [appLink]="navItem.link | cmsUrl:cmsLocale"
                                               [target]="navItem.openTab ? '_blank' : '_self'"
                                               (click)="cmsOpenIndex = null">
                                                {{ navItem.label }}
                                            </a>
                                            @if (navItem.subtitle) {
                                                <span class="cms-mega-menu__subtitle">{{ navItem.subtitle }}</span>
                                            }
                                        </li>
                                    }
                                </ul>
                            </div>
                        }
                    </div>
                </span>
            <!-- Contentstack link entry: a single navigation link with no sub-items -->
            } @else if (section.link; as lnk) {
                <span class="categoryLink dotcom-nav-item dotcom-nav-item--cms">
                    <a class="cms-nav-link"
                       [appLink]="lnk.link | cmsUrl:cmsLocale"
                       [target]="lnk.openInTab ? '_blank' : '_self'">
                        {{ formatNavLabel(lnk.label) }}
                    </a>
                </span>
            }
        }
    }
<!-- Non-CMS markets: nav items come from TEAS translation keys (menu.0-5.{url,name,target}) -->
} @else {
    @for (item of menuItems; track item.url) {
        <span class="categoryLink dotcom-nav-item">
            <!-- "Shop" override: replaces the cart landing link with a toggle button for the Shop sub-nav -->
            @if (isShopUrl(item.url)) {
                <button class="cms-nav-trigger"
                        type="button"
                        (click)="toggleCmsSection($event, -1)"
                        [attr.aria-expanded]="cmsOpenIndex === -1"
                        [attr.data-testid]="'dotcom-nav-shop'"
                        [class.cms-nav-trigger--active]="cmsOpenIndex === -1">
                    {{ item.name | uppercase }}
                    <i class="fa-solid fa-chevron-down cms-nav-chevron"
                       [class.cms-nav-chevron--open]="cmsOpenIndex === -1"></i>
                </button>
                <div class="dropdown-menu cms-mega-menu" [class.show]="cmsOpenIndex === -1">
                    <shop-nav-full-menu (closeMenu)="cmsOpenIndex = null"></shop-nav-full-menu>
                </div>
            <!-- Standard translated nav link -->
            } @else {
                <a class="non-cms-nav-link"
                   [appLink]="item.url"
                   [target]="item.target || '_self'"
                   [attr.data-testid]="'dotcom-nav-' + item.url.split('/').pop()"
                   [innerHTML]="item.name | uppercase"></a>
            }
        </span>
    }
}
